module.exports = __webpack_public_path__ + "static/media/indesign.dc345305.svg";